import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/table-actions-mobile.css';
import App from './App';
import StagingBanner from './components/StagingBanner';
import SupportContextBanner from './components/SupportContextBanner';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './store';
import { BrowserRouter } from 'react-router-dom';
import { installContextInterceptor } from './api/contextInterceptor';

installContextInterceptor(store);
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <React.StrictMode>
        <StagingBanner />
        <SupportContextBanner />
        <App />
      </React.StrictMode>
    </BrowserRouter>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
